import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getEventPaymentInfo, listLocationPayments, saveLocationPayment } from "@/api/locations";
import { locationPaymentKeys } from "@/api/queryKeys";
import type { HostPaymentRow } from "@shared/hostPayment";

/** The host's payment details for an event, or null to pay us via Stripe. */
export function useEventPaymentInfo(eventId: number, enabled: boolean) {
  return useQuery({
    queryKey: locationPaymentKeys.event(eventId),
    queryFn: () => getEventPaymentInfo(eventId),
    enabled,
  });
}

/** Payment details of every location the caller may edit, by location_id. */
export function useLocationPayments(enabled: boolean) {
  return useQuery({
    queryKey: locationPaymentKeys.list,
    queryFn: listLocationPayments,
    enabled,
  });
}

export function useSaveLocationPayment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ locationId, row }: { locationId: number; row: HostPaymentRow }) =>
      saveLocationPayment(locationId, row),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: locationPaymentKeys.all }),
  });
}
